import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import ContactUsModal from './ContactUsModal';
import TermsOfServicesModal from './TermsOfServicesModal';
import ForgotPasswordModal from './ForgotPasswordModal';

const Modals = ({ i18n }) => (
  <Fragment>
    <ForgotPasswordModal i18n={i18n} />
    <ContactUsModal i18n={i18n} />
    <TermsOfServicesModal i18n={i18n} />
  </Fragment>
);

export default withRouter(Modals);



// WEBPACK FOOTER //
// ./src/components/Modals/index.js